import { render, staticRenderFns } from "./ProductItemModal.vue?vue&type=template&id=4f4c631c&scoped=true"
import script from "./ProductItemModal.vue?vue&type=script&lang=js"
export * from "./ProductItemModal.vue?vue&type=script&lang=js"
import style0 from "./ProductItemModal.vue?vue&type=style&index=0&id=4f4c631c&prod&lang=scss&scoped=true"
import style1 from "./ProductItemModal.vue?vue&type=style&index=1&id=4f4c631c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c631c",
  null
  
)

export default component.exports